import { createContext, useContext, useState } from "react";
const AlertContext = createContext();


const AlertProvider = ({ children }) => {
  const [alertControl, setAlertControl] = useState(false);
  const [alert, setAlert] = useState({
    msg: '',
    type: ''
  });

  const showAlert = (messeage, type, label) => {

    setAlertControl(true)
    setAlert({
      msg: messeage,
      type: type,
      label:label
    })

    setTimeout(() => {
      setAlert({});
      setAlertControl(false)
    }, 3000);

  }

  return (
    <AlertContext.Provider value={{ alert, showAlert, alertControl }}>
      {children}
    </AlertContext.Provider>
  )
}

const useAlertContext = () => {
  return useContext(AlertContext);
}

export { AlertProvider, AlertContext, useAlertContext }
